import { NgModule } from '@angular/core';
import { MyLibComponent } from './my-lib.component';
import { MyLibRoutingModule } from './my-lib-routing.module';
import { LibBaseComponent } from './lib-base/lib-base.component';



@NgModule({
  declarations: [
    MyLibComponent,
    LibBaseComponent
  ],
  imports: [
    // MyLibRoutingModule
  ],
  exports: [
    MyLibComponent,
    // MyLibRoutingModule
  ]
})
export class MyLibModule { }
